(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-service/assets/javascripts/utils/url.js') >= 0) return;  svs.modules.push('/components/racing/race-service/assets/javascripts/utils/url.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ref = svs.isServer ? require('@svenskaspelab/trinidad-core').core.components.require('racing', 'common').constants : svs.racing.common.constants,
  gameTypes = _ref.gameTypes,
  menuItems = _ref.menuItems,
  XPERTEN = _ref.XPERTEN;
const strings = svs.isServer ? require('@svenskaspelab/trinidad-core').core.components.require('racing', 'common').strings : svs.racing.common.strings;
const createPlayPath = _ref2 => {
  let day = _ref2.day,
    trackName = _ref2.trackName,
    raceNumber = _ref2.raceNumber,
    gameType = _ref2.gameType,
    xpert = _ref2.xpert,
    menuItem = _ref2.menuItem;
  let url = '';
  const queries = [];
  url += "/".concat(trackName);
  url += "/lopp-".concat(raceNumber);
  if (gameType) {
    const gameTypeName = strings.getProductUrlName(gameType);
    url += "/".concat(gameTypeName);
    if (xpert) {
      url += "/".concat(XPERTEN);
    }
  }
  url += "/".concat(day);

  if (!svs.isServer) {
    const searchParams = new URLSearchParams(window.location.search);
    for (const _ref3 of searchParams.entries()) {
      var _ref4 = _slicedToArray(_ref3, 2);
      const key = _ref4[0];
      const value = _ref4[1];
      if (key === 'menuItem' && searchParams.has('flik') || key === 'menuItem') {
        continue;
      }
      queries.push("".concat(key, "=").concat(value));
    }
  }

  if (menuItem && menuItem !== menuItems.COUPON) {
    queries.push("menuItem=".concat(menuItem));
  }
  if (queries.length > 0) {
    url += "?".concat(queries.join('&'));
  }
  return url;
};
const createTopp5Path = () => "/".concat(gameTypes.TOPP5);
if (svs.isServer) {
  module.exports = {
    createPlayPath
  };
} else {
  svs.racing.raceService.utils.url = {
    createPlayPath,
    createTopp5Path
  };
}

 })(window);